import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OAuthCallback from './components/OAuthCallback';
import NotFound from './components/NotFound';
import Home from './components/Home';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
